import { Body1, Flex, Stack, Subtitle2 } from "@myphx-engineering/phx-design-system";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/pricing-info/PricingInfo.tsx
const PricingInfo = ({ option, details, value }) => {
	return /* @__PURE__ */ jsxs(Flex, {
		justify: "space-between",
		children: [/* @__PURE__ */ jsxs(Stack, {
			gap: 0,
			children: [/* @__PURE__ */ jsx(Subtitle2, { children: option }), details ? /* @__PURE__ */ jsx(Body1, { children: details }) : null]
		}), /* @__PURE__ */ jsx(Subtitle2, { children: value })]
	});
};

//#endregion
export { PricingInfo };